

import React, { useEffect } from "react";

const ModalDeleteEffect: React.FC = () => {
  useEffect(() => {
    const styleId = "modal-delete-shake-animations";
    if (!document.getElementById(styleId)) {
      const styleSheet = document.createElement("style");
      styleSheet.id = styleId;
      styleSheet.innerText = `
        /* 🔄 Rotate + Shake Entrance */
        @keyframes modalRotateShakeIn {
          0% {
            opacity: 0;
            transform: scale(0.88) rotate(-6deg) translateY(-20px);
          }
          30% {
            opacity: 0.7;
            transform: scale(1.04) rotate(4deg) translateX(-6px);
          }
          45% {
            transform: scale(0.98) rotate(-3deg) translateX(6px);
          }
          60% {
            transform: scale(1.02) rotate(2deg) translateX(-4px);
          }
          75% {
            transform: scale(0.99) rotate(-1deg) translateX(4px);
          }
          90% {
            transform: scale(1.01) rotate(0.5deg);
          }
          100% {
            opacity: 1;
            transform: scale(1) rotate(0deg) translateX(0);
          }
        }

        /* Pulsing red glow (unchanged) */
        @keyframes pulseGlow {
          0%   { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.55); }
          70%  { box-shadow: 0 0 0 14px rgba(239, 68, 68, 0); }
          100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
        }

        /* SAME CLASS NAME — NEW ROTATE + SHAKE EFFECT */
        .effect-modal-show.show .modal-content {
          animation: modalRotateShakeIn 0.75s
            cubic-bezier(0.34, 0, 0.66, 1.25);
          transform-origin: center;
        }

        /* Danger icon pulse */
        .effect-avatar-pulse {
          animation: pulseGlow 2.1s infinite ease-out;
          border-radius: 50%;
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, []);

  return null;
};

export default ModalDeleteEffect;
